import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Category from "./pages/Category";
import Subcategory from "./pages/Subcategory";
import Products from "./pages/Products";
import About from "./pages/About";
import Orders from "./pages/admin/Orders";
import Customers from "./pages/admin/Customers";
import Payments from "./pages/admin/Payments";
import ProfilePage from "./pages/admin/Profilepage";
import Notifications from "./pages/admin/Notifications";
import Offers from "./pages/admin/Offers";
import Coupons from "./pages/Coupon";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import TopPicks from "./pages/admin/TopPicks";
import ProtectedRoute from "./components/ProtectedRoute";
import PermissionGate from "./components/PermissionGate";
import Enquiries from "./pages/admin/Enquiries";
import Settings from "./pages/admin/settings";
import Banners from "./pages/admin/Banners";
import Scrollbar from "./pages/scrollbar";
import ContactEnquiries from "./pages/contact";
import Reports from "./pages/Reports";
import RolesPermissions from "./pages/rolespage";
import SuperCoins from "./pages/supercoins";
import GiftPacking from "./pages/Giftpacking";
import Employees from "./pages/employe";
import "./premium-admin.css";

const AdminPage = ({ module, action = "view", children }) => (
  <ProtectedRoute>
    <PermissionGate module={module} action={action}>{children}</PermissionGate>
  </ProtectedRoute>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Navigate to="/admin/login" />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/*" element={<ResetPassword />} />

        <Route path="/admin/dashboard" element={<AdminPage module="dashboard"><Dashboard /></AdminPage>} />
        <Route path="/admin/category" element={<AdminPage module="categories"><Category /></AdminPage>} />
        <Route path="/admin/subcategory" element={<AdminPage module="subcategories"><Subcategory /></AdminPage>} />
        <Route path="/admin/products" element={<AdminPage module="products"><Products /></AdminPage>} />
        <Route path="/admin/about" element={<AdminPage module="about"><About /></AdminPage>} />
        <Route path="/admin/orders" element={<AdminPage module="orders"><Orders /></AdminPage>} />
        <Route path="/admin/customers" element={<AdminPage module="customers"><Customers /></AdminPage>} />
        <Route path="/admin/contact" element={<AdminPage module="contact"><ContactEnquiries /></AdminPage>} />
        <Route path="/admin/payments" element={<AdminPage module="payments"><Payments /></AdminPage>} />
        <Route path="/admin/supercoins" element={<AdminPage module="supercoins"><SuperCoins /></AdminPage>} />
        <Route path="/admin/giftpacking" element={<AdminPage module="giftpacking"><GiftPacking /></AdminPage>} />
        <Route path="/admin/notifications" element={<AdminPage module="notifications"><Notifications /></AdminPage>} />
        <Route path="/admin/offers" element={<AdminPage module="offers"><Offers /></AdminPage>} />
        <Route path="/admin/coupons" element={<AdminPage module="coupons"><Coupons /></AdminPage>} />
        <Route path="/admin/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
        <Route path="/admin/toppicks" element={<AdminPage module="toppicks"><TopPicks /></AdminPage>} />
        <Route path="/admin/enquiries" element={<AdminPage module="enquiries"><Enquiries /></AdminPage>} />
        <Route path="/admin/reports" element={<AdminPage module="reports"><Reports /></AdminPage>} />
        <Route path="/admin/roles" element={<AdminPage module="roles"><RolesPermissions /></AdminPage>} />
        <Route path="/admin/employees" element={<AdminPage module="employees"><Employees /></AdminPage>} />
        <Route path="/admin/settings" element={<AdminPage module="settings"><Settings /></AdminPage>} />
        <Route path="/admin/banners" element={<AdminPage module="banners"><Banners /></AdminPage>} />
        <Route path="/admin/scrollbar" element={<AdminPage module="scrollbar"><Scrollbar /></AdminPage>} />
      </Routes>
    </Router>
  );
}

export default App;
